module.exports = __webpack_public_path__ + "img/gerüstbohlen-möbel-tisch-lisa.02abb497.jpg";